import { Injectable, inject } from '@angular/core';
import { ApplicationStatus } from '@mkp/application/models';
import { CoreListEnvelop } from '@mkp/shared/models';
import { BaseHttpResource } from '@mkp/shared/data-access';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { map, Observable } from 'rxjs';
import { ApplicationStatusDto } from './application-status.dto';
import { mapApplicationStatusDtoToModel } from './application-status.mapper';

@Injectable({
  providedIn: 'root',
})
export class ApplicationStatusResource extends BaseHttpResource<
  ApplicationStatusDto,
  CoreListEnvelop<ApplicationStatusDto>,
  ApplicationStatus
> {
  private readonly environment = inject(ENVIRONMENT_PROVIDER);

  constructor() {
    super('application-status');
  }

  list(accountId: string): Observable<ApplicationStatus[]> {
    return this.http
      .get<CoreListEnvelop<ApplicationStatusDto>>(
        `${this.environment.api.ats}/account/${accountId}/${this.uri}`,
        {
          params: { sort: 'step=asc' },
        }
      )
      .pipe(
        map(({ _embedded: { results: applicationStatusDtos } }) =>
          applicationStatusDtos.map(mapApplicationStatusDtoToModel)
        )
      );
  }
}
